import { Modal } from "@circleco/compass/components/Modal";

import { useFormRenderingContext } from "../contexts/FormRenderingContext";
import { FormContent } from "../FormContent";
import { useModalCookie } from "../hooks/useModalCookie";

interface FormModalCompassProps {
  onOpenChange: (open: boolean) => void;
  open: boolean;
}

export const FormModalCompass = ({
  open,
  onOpenChange,
}: FormModalCompassProps) => {
  const {
    form,
    index,
    shouldRenderEndingPage,
    titleElement,
    formBackgroundColor,
    formTextColor,
    initialFocusRef,
  } = useFormRenderingContext();
  const { suppressPopupForm } = useModalCookie();

  const showTitle = !shouldRenderEndingPage && titleElement;

  const handleClose = () => {
    suppressPopupForm();
    onOpenChange(false);
    // eslint-disable-next-line sonarjs/post-message -- Disabled for plugin version update. Fix when possible.
    window.parent.postMessage(
      { type: "resize", formUid: form.uid, formIndex: index, height: "0" },
      "*",
    );
  };

  const modalContentId = `form-modal-${form.uid}`;

  return (
    <Modal.Root
      open={open}
      onOpenChange={handleClose}
      size="md"
      initialFocus={initialFocusRef}
    >
      <Modal.Content>
        <style data-form-modal={modalContentId}>
          {`
            div:has(> style[data-form-modal="${modalContentId}"]) {
              background-color: ${formBackgroundColor};
            }
            style[data-form-modal="${modalContentId}"] ~ header h4,
            style[data-form-modal="${modalContentId}"] ~ header button {
              color: ${formTextColor} !important;
            }
          `}
        </style>
        <Modal.Header title={showTitle ? titleElement.attributes.value : ""} />
        <Modal.Body>
          <FormContent />
        </Modal.Body>
      </Modal.Content>
    </Modal.Root>
  );
};
